import './App.css';
import React from 'react';
import MainComponent from './components/MainComponent';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { teal } from '@material-ui/core/colors';

const theme = createMuiTheme({
  palette: {
    primary: { main: teal[500] }
  },
  typography: { useNextVariants: true }
});

const App = () => (
  <MuiThemeProvider theme={theme}>
    <MainComponent />
  </MuiThemeProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx